import { render, staticRenderFns } from "./SegmentController.vue?vue&type=template&id=22200952&scoped=true&"
import script from "./SegmentController.vue?vue&type=script&lang=js&"
export * from "./SegmentController.vue?vue&type=script&lang=js&"
import style0 from "./SegmentController.vue?vue&type=style&index=0&id=22200952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22200952",
  null
  
)

export default component.exports